export default "__VITE_ASSET__DW7hU$6r__"